import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the phone off icon
 * 
 * @param {Object} props - The props of the component
 * @returns The phone off icon
 */
const PhoneOff = (props) => (
  <Icon viewBox="0 0 21 22" fill="none" {...props}>
    <path d="M19.4611 21.1667C17.0691 21.1667 14.7059 20.6452 12.3713 19.6023C10.0367 18.5594 7.91265 17.0812 5.99907 15.1676C4.08549 13.254 2.60725 11.1299 1.56435 8.79537C0.521451 6.4608 0 4.09753 0 1.70556C0 1.36111 0.114815 1.07407 0.344444 0.844444C0.574074 0.614815 0.861111 0.5 1.20556 0.5H5.85556C6.12346 0.5 6.36265 0.590895 6.57315 0.772685C6.78364 0.954475 6.90802 1.16975 6.9463 1.41852L7.69259 5.43704C7.73086 5.74321 7.7213 6.00154 7.66389 6.21204C7.60648 6.42253 7.50123 6.60432 7.34815 6.75741L4.56389 9.57037C4.9466 10.2784 5.40108 10.9625 5.92731 11.6227C6.45355 12.2829 7.03241 12.9191 7.66389 13.5315C8.2571 14.1247 8.87901 14.6748 9.52963 15.1819C10.1802 15.689 10.8691 16.1531 11.5963 16.5741L14.2944 13.8759C14.4667 13.7037 14.6915 13.5745 14.969 13.4884C15.2464 13.4023 15.5191 13.3784 15.787 13.4167L19.7481 14.2204C20.016 14.2969 20.2361 14.4356 20.4083 14.6366C20.5806 14.8375 20.6667 15.0623 20.6667 15.3111V19.9611C20.6667 20.3056 20.5519 20.5926 20.3222 20.8222C20.0926 21.0519 19.8056 21.1667 19.4611 21.1667Z" fill="currentColor" />
  </Icon>
);

export default React.memo(PhoneOff);
